<div class="heading w-100">
    <p-tabView orientation="right" (onChange)="selectTab($event)" [activeIndex]="index">
        <p-tabPanel header="Projects">
            <ng-template pTemplate="content">
                <div>
                    <acabim-datatable
                        #projectsTable
                        [dataSources]="projectDataSources"
                        [hasDetailView]="true"
                        [helpMessage]="helpMessage"
                        dataKey="id"></acabim-datatable>
                    <div class="cas-action-buttons cas-action-buttons-bottom">
                        <button type="button" (click)="onAddNewProject()" class="cas-button-action cas-button-right">Add project</button>
                    </div>
                </div>
            </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Archived Projects">
            <ng-template pTemplate="content">
                <acabim-admin-archived-projects #archivedProjectsTable [_currentSite]="_currentSite"></acabim-admin-archived-projects>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
</div>

<acabim-modal
    [title]="archiveCardTitle"
    [display]="displayArchiveModal"
    (status)="setModal($event)"
    fixHeight="80vh"
    width="80vw"
    [footer]="false">
    <div *ngIf="(!isLoading) else loadingView">
        <div *ngIf="!archiveError">
            <div class="p-d-flex flex-column">
                <div class="p-d-flex flex-row">
                    <p>Do you really want to archive this project:</p>
                </div>
                <div class="p-d-flex flex-row">
                    <acabim-data-display [dataMap]="archivedProjectData" labelWidth="20rem"></acabim-data-display>
                </div>
            </div>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="archiveAction(false)">Cancel</button>
                <button (click)="archiveAction(true)" class="cas-button-action cas-button-right">Archive</button>
            </div>
        </div>
    </div>
</acabim-modal>

<acabim-modal
    [title]="'Error'"
    [display]="archiveError"
    (status)="setErrorModal($event)"
    [footer]="false">
    <div *ngIf="(!isLoading) else loadingView">
        <span>Error: Cannot archive project {{errorMessage}},
        Please close {{count}} related work orders
        </span>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button (click)="setErrorModal(false)">Close</button>
            <button (click)="forceArchive()" class="cas-button-action cas-button-right" *ngIf="superAdmin">Confirm</button>
        </div>
    </div>
</acabim-modal>

<acabim-modal
        [display]="projectDataSources[0].showDetails"
        [title]="projectDataSources[0]?.detailData?.name"
        fixHeight="80vh"
        width="80vw"
        (status)="setEditModal($event)"
        [dontClose]="!editClosable">
    <acabim-admin-edit-project
       *ngIf="projectDataSources[0].showDetails"
       [selectedProject]="projectDataSources[0].detailData"
       (closeDialog)="close($event)"
       (closable)="setEditClosable($event)"></acabim-admin-edit-project>
</acabim-modal>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<acabim-modal
    [title]="'Create project'"
    [display]="displayAddProjectModal"
    [dontClose]="!closable"
    fixHeight="80vh"
    width="80vw"
    (status)="closeModal($event)">
    <acabim-admin-create-project [site]="_currentSite" (projectCreated)="onNewProjectCreated($event)"></acabim-admin-create-project>
</acabim-modal>

<acabim-modal
    [title]="'Move project'"
    [display]="moveProject"
    (status)="setMoveProjectModal($event)"
    [footer]="false"
    fixHeight="80vh"
    [dontClose]="true"
    width="80vw">
    <acabim-admin-move-project [project]="projectDataSources[0].selectedData[0]"
                               [site]="_currentSite" (close)="setMoveProjectModal(false)"></acabim-admin-move-project>
</acabim-modal>

<p-toast position="center"></p-toast>
